// extracted by css-extract-rspack-plugin
export default {"container":"_d8164ac1","arrow":"_f325d91f"};